import React from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import ModuleMark from "./ModuleMark";

/**
 * PageHeader — the page-head band: gradient module mark, optional eyebrow,
 * an h1 title and a right-aligned action cluster.
 * Template ref: `.pageHead` + `.titleArea` + `.headRight`.
 *
 * Props:
 *   moduleCode - short code for the ModuleMark (omit to hide the mark)
 *   eyebrow    - small uppercase label above the title
 *   title      - h1 text (string or node)
 *   actions    - right-aligned node(s), typically buttons
 */
const PageHeader = ({ moduleCode, eyebrow, title, actions, ...rest }) => (
  <Flex
    align="center"
    justify="space-between"
    px="20px"
    py="14px"
    gap="12px"
    flexWrap="wrap"
    borderBottomWidth="1px"
    borderColor="portal.line"
    bgGradient="linear(100deg, #F8FBFD 0%, #FFFFFF 56%, #EEF4F8 100%)"
    {...rest}
  >
    <Flex align="center" gap="14px" minW={0}>
      {moduleCode && <ModuleMark code={moduleCode} />}
      <Box minW={0}>
        {eyebrow && (
          <Text
            textTransform="uppercase"
            fontSize="11px"
            fontWeight="800"
            letterSpacing="0.08em"
            color="portal.muted"
            sx={{ marginBottom: "2px !important" }}
          >
            {eyebrow}
          </Text>
        )}
        <Heading
          as="h1"
          fontSize="21px"
          lineHeight="1.1"
          letterSpacing="-0.04em"
          color="portal.text"
          isTruncated
          sx={{ marginBottom: "0 !important" }}
        >
          {title}
        </Heading>
      </Box>
    </Flex>
    {actions && (
      <Flex align="center" gap="8px" flexShrink={0}>
        {actions}
      </Flex>
    )}
  </Flex>
);

export default PageHeader;
